import { Crisp } from "crisp-sdk-web"

interface ApiDeApresentacaoCrisp {
  injetado: () => boolean
  mostrar: () => void
  ocultar: () => void
  abrir: () => void
  fechar: () => void
}

export class ApresentacaoDoCrisp {
  private disponivel = false
  private compacto = false
  private conversaDaNinaVisivel = false
  private aberto = false
  private abertura?: Promise<boolean>
  private concluirAbertura?: (abriu: boolean) => void
  private tempoLimite?: ReturnType<typeof setTimeout>

  constructor (private readonly api: ApiDeApresentacaoCrisp) {}

  atualizar (disponivel: boolean, compacto: boolean, conversaDaNinaVisivel = false): void {
    const restaurarVisibilidade = this.conversaDaNinaVisivel && !conversaDaNinaVisivel
    this.conversaDaNinaVisivel = conversaDaNinaVisivel
    this.disponivel = disponivel
    this.compacto = compacto
    if (!disponivel) {
      this.aberto = false
    }
    if (!disponivel || conversaDaNinaVisivel) this.concluir(false)
    this.aplicar(restaurarVisibilidade)
  }

  aoCarregar (): void { this.aplicar() }

  aoAbrir (): void {
    if (!this.disponivel) {
      if (this.api.injetado()) this.api.ocultar()
      return
    }
    this.aberto = true
    this.concluir(!this.conversaDaNinaVisivel)
    if (this.conversaDaNinaVisivel) this.aplicar()
  }

  aoFechar (): void {
    this.aberto = false
    this.concluir(false)
    this.aplicar()
  }

  abrir (): Promise<boolean> {
    if (!this.disponivel || this.conversaDaNinaVisivel) return Promise.resolve(false)
    if (this.aberto) return Promise.resolve(true)
    if (this.abertura) return this.abertura
    this.abertura = new Promise(resolve => { this.concluirAbertura = resolve })
    const abertura = this.abertura
    this.tempoLimite = setTimeout(() => {
      this.api.fechar()
      this.concluir(false)
      this.aplicar()
    }, 10000)
    try {
      this.api.mostrar()
      this.api.abrir()
    } catch {
      this.concluir(false)
      this.aplicar()
    }
    return abertura
  }

  private aplicar (restaurarVisibilidade = false): void {
    if (!this.api.injetado()) return
    if (!this.disponivel || this.conversaDaNinaVisivel || (this.compacto && !this.aberto && !this.abertura)) this.api.ocultar()
    else if (restaurarVisibilidade || (!this.aberto && !this.abertura)) this.api.mostrar()
  }

  private concluir (abriu: boolean): void {
    clearTimeout(this.tempoLimite)
    this.concluirAbertura?.(abriu)
    this.concluirAbertura = undefined
    this.abertura = undefined
  }
}

const apresentacao = new ApresentacaoDoCrisp({
  injetado: () => Crisp.isCrispInjected(),
  mostrar: () => Crisp.chat.show(),
  ocultar: () => Crisp.chat.hide(),
  abrir: () => Crisp.chat.open(),
  fechar: () => Crisp.chat.close()
})
let eventosRegistrados = false

export function registrarEventosDeApresentacaoCrisp (): void {
  if (eventosRegistrados) return
  Crisp.chat.onChatOpened(() => apresentacao.aoAbrir())
  Crisp.chat.onChatClosed(() => apresentacao.aoFechar())
  Crisp.session.onLoaded(() => apresentacao.aoCarregar())
  eventosRegistrados = true
}

export function sincronizarApresentacaoCrisp (disponivel: boolean, compacto: boolean, conversaDaNinaVisivel = false): void {
  apresentacao.atualizar(disponivel, compacto, conversaDaNinaVisivel)
}

export function aplicarApresentacaoCrispAposCarregamento (): void {
  apresentacao.aoCarregar()
}

export function abrirChatCrisp (): Promise<boolean> { return apresentacao.abrir() }

export function deveInicializarCrisp (crispAtivoFlagsmith: boolean): boolean {
  if (!crispAtivoFlagsmith) return false
  const ehHomolog = window.location.href.includes('hml.pontotel.com.br/pontotel/new-front/')
  // O alpha do Assistente é onde se valida a passagem da Nina para o suporte;
  // é build de desenvolvimento, então precisa de liberação própria. A flag por
  // empresa continua mandando.
  const ehAlphaDoAssistente = window.location.href.includes('hml.pontotel.com.br/alpha-arquitetos/new-front/')
  const ehProducao = process.env.NODE_ENV === 'production'
  return ehHomolog || ehAlphaDoAssistente || ehProducao
}
